import { toCsv } from './utils.ts';

export const CSV_UTF8_MIME_TYPE = 'text/csv;charset=utf-8;';

export function download(data: string, type: string, filename: string) {
    const blob = new Blob([data], { type });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const generateAndDownloadReport = <T extends Record<string, unknown>>(
    dataToExport: T[],
    filename: string,
) => {
    const csvString = toCsv(dataToExport);
    if (!csvString) {
        throw new Error(
            'Failed to convert data to CSV format. Please check the input data for any issues.',
        );
    }
    download(csvString, CSV_UTF8_MIME_TYPE, filename);
};
